import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { isInteger, isEmpty, isEqual } from 'lodash'

// State
import { getProduct, unloadProduct } from '../../store/actions/product'
import { unloadSelectedVariants } from '../../store/actions/productVariant'

// Components
import Loader from '../utils/Loader'
import Promos from '../home/Promos'
import SuggestedProducts from '../SuggestedProducts'
import ProductImages from './ProductImages'
import ProductContent from './ProductContent'
import Breadcrumb from '../Breadcrumb'

// Utils

class Product extends Component {
	static initialAction(store, props) {
		// console.log("Product initialAction");

		const permalink = props.params ? props.params.permalink : props.match.params.permalink
		const category = props.params ? props.params.category : props.match.params.category
		const res =
			store !== null ? getProduct(permalink, category) : props.getProduct(permalink, category)
		return res
	}

	componentWillReceiveProps(nextProps) {
		// If new product is to be shown
		if (
			!!nextProps.product.product &&
			!!nextProps.product.product.product &&
			!isEqual(this.props.product.product, nextProps.product.product)
		) {
			this.props.unloadSelectedVariants()

			var categories = ''
			for (var i = 0; i < nextProps.product.structure.length; i++) {
				if (categories !== '') {
					categories += '/'
				}
				categories += nextProps.product.structure[i].title
			}

			var productData = {
				id: nextProps.product.product.sku,
				name: nextProps.product.product.title,
				category: categories,
				price: nextProps.product.product.price,
			}

			// ✅ Use Google Analytics only in browser (not SSR)
			if (typeof window !== 'undefined') {
				const { addProductView } = require('../../utils/google-analytics')
				addProductView(productData)
			}
		}
	}

	componentDidMount() {
		// console.log(this.props.product);

		// console.log('Product Mounted:', this.props.product.id, isInteger(this.props.product.id))
		if (!isInteger(this.props.product.product.id)) {
			// console.log("Calling initialAction from PRODUCT componentDidMount");
			Product.initialAction(null, this.props)
		}
	}

	componentDidUpdate(nextProps) {
		// console.log('Product Update:', nextProps.match.params.permalink, this.props.match.params.permalink)
		if (nextProps.match.params.permalink !== this.props.match.params.permalink) {
			// console.log('Calling initialAction from componentDidUpdate')
			Product.initialAction(null, this.props)
		}
	}

	componentWillUnmount() {
		// console.log('Product Unmount')
		this.props.unloadProduct()
	}

	render() {
		// console.log('Product render', this.props.match.params.permalink)
		// console.log("Product render", this.props.product);

		let renderObj = <Loader />
		let helmet = null

		if (this.props.product.error) {
			renderObj = <div className='error'>{this.props.product.error}</div>
		} else if (!this.props.product.isLoading && !this.props.product.product.title) {
			renderObj = <div className='error'>Product Not Found</div>
		} else if (!this.props.product.isLoading) {
			const product = this.props.product.product
			const structure = this.props.product.structure

			// ===================================
			//	Put meta tags together
			// ===================================
			// Page title
			let title = ''
			if (this.props.siteInfo.site) {
				title += this.props.siteInfo.site.title + ' | '
			}
			title += product.title

			// Description
			let desc = ''
			if (!isEmpty(product.description)) {
				desc += product.description + ' - '
			}
			desc += product.sku

			// OG title
			let ogTitle = product.title

			// OG image
			let ogImage = ''
			if (product.images && product.images.length) {
				ogImage = product.images[0].img
			} else if (this.props.siteInfo.site && !isEmpty(this.props.siteInfo.site.logo)) {
				ogImage = this.props.siteInfo.site.logo
			}

			// console.log('Product title:', title)

			// Show meta tags
			helmet =
				title !== '' ? (
					<Helmet>
						<title>{title}</title>
						<meta name='description' content={desc} />
						<meta property='og:title' content={title} />
						<meta property='og:description' content={desc} />
						<meta property='twitter:title' content={ogTitle} />
						<meta property='og:image' content={ogImage} />
						<meta property='og:image:width' content='200' />
						<meta property='og:image:height' content='200' />
					</Helmet>
				) : null

			// Show product
			renderObj = (
				<div>
					<ProductImages siteInfo={this.props.siteInfo} images={product.images} product={product} />
					<ProductContent
						siteInfo={this.props.siteInfo}
						product={product}
						variant={this.props.variant}
						variantsSelected={this.props.variantsSelected}
						structure={structure}
						mainProduct={1}
					/>
				</div>
			)
		}

		return (
			<div>
				{helmet}
				<div className='body_container'>
					<Breadcrumb structure={this.props.product.structure} />
					<div className='pt2'>
						<main className='product_section'>{renderObj}</main>
						<SuggestedProducts permalink={this.props.match.params.permalink} />
					</div>
				</div>
				<Promos />
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo,
		product: state.product,
		variant: state.productVariant.variant,
		variantsSelected: state.productVariant.variant_options,
	}
}

export default connect(mapStateToProps, { getProduct, unloadProduct, unloadSelectedVariants })(
	Product
)



// WEBPACK FOOTER //
// ./src/components/product/Product.js